import { Box, Chip, Tooltip } from "@mui/material";
import { riskScoreStyle, parseRiskFactors } from "./assetUtils";

// Risk in a table row, as a band label only.
//
// The raw 0–100 score is precision nobody scans a table for: 62 and 67 land in the
// same bucket and prompt the same action, so printing both invites a comparison
// that means nothing. The band is the decision; the number and the full
// `risk_factors` breakdown stay one hover away, and the asset's Security tab
// renders the whole cascade.
const AssetRiskChip = ({ score, factors }) => {
  const style = riskScoreStyle(score);
  const parsed = parseRiskFactors(factors);

  const title = (
    <Box>
      <div style={{ fontWeight: 700, marginBottom: parsed.length > 0 ? 3 : 0 }}>
        Risk {typeof score === "number" ? `${score}/100` : "—"} · {style.label}
      </div>
      {parsed.map((f, i) => (
        <div key={i} style={{ fontSize: 11 }}>
          {f.weight != null ? `+${f.weight}` : "—"} · {f.label}
        </div>
      ))}
    </Box>
  );

  return (
    <Tooltip title={title}>
      <Chip
        label={style.label}
        size="small"
        sx={{ bgcolor: style.bg, color: style.color, fontWeight: 700, fontSize: 10.5, height: 20, minWidth: 74 }}
      />
    </Tooltip>
  );
};

export default AssetRiskChip;
